import * as React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <path
        d="M14.1297 11.3386C14.5197 9.69856 13.0897 8.26856 11.4497 8.65856C10.6797 8.84856 10.0497 9.47856 9.85974 10.2486C9.46974 11.8886 10.8997 13.3186 12.5397 12.9286C13.3197 12.7386 13.9497 12.1086 14.1297 11.3386Z"
        fill="#fff"
      />
      <path
        d="M6.02094 17.97C5.84094 17.97 5.65094 17.9 5.51094 17.77C3.57094 15.97 2.46094 13.43 2.46094 10.79C2.46094 5.53 6.74094 1.25 12.0009 1.25C17.2609 1.25 21.5409 5.53 21.5409 10.79C21.5409 13.45 20.4709 15.91 18.5309 17.74C18.2309 18.02 17.7509 18.01 17.4709 17.71C17.1909 17.41 17.2009 16.93 17.5009 16.65C19.1409 15.11 20.0409 13.04 20.0409 10.8C20.0409 6.37 16.4309 2.76 12.0009 2.76C7.57094 2.76 3.96094 6.37 3.96094 10.8C3.96094 13.06 4.87094 15.14 6.53094 16.68C6.83094 16.96 6.85094 17.44 6.57094 17.74C6.42094 17.89 6.22094 17.97 6.02094 17.97Z"
        fill="#fff"
      />
      <path
        d="M15.9995 15.2986C15.8195 15.2986 15.6295 15.2286 15.4895 15.0986C15.1895 14.8186 15.1695 14.3386 15.4595 14.0386C16.2895 13.1586 16.7495 11.9986 16.7495 10.7986C16.7495 8.17859 14.6195 6.05859 12.0095 6.05859C9.39953 6.05859 7.26953 8.18859 7.26953 10.7986C7.26953 12.0086 7.72953 13.1586 8.55953 14.0386C8.83953 14.3386 8.82953 14.8186 8.52953 15.0986C8.22953 15.3886 7.74953 15.3686 7.46953 15.0686C6.37953 13.9086 5.76953 12.3886 5.76953 10.7986C5.76953 7.35859 8.56953 4.55859 12.0095 4.55859C15.4495 4.55859 18.2495 7.35859 18.2495 10.7986C18.2495 12.3886 17.6495 13.9086 16.5495 15.0686C16.3995 15.2186 16.1995 15.2986 15.9995 15.2986Z"
        fill="#fff"
      />
      <path
        d="M10.3009 16.66L8.86086 18.45C7.72086 19.88 8.74086 22 10.5609 22H13.4309C15.2609 22 16.2809 19.88 15.1309 18.46L13.6909 16.67C12.8309 15.57 11.1709 15.57 10.3009 16.66Z"
        fill="#fff"
      />
    </Svg>
  );
};

export default Icon;
